import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import GuestChatWidget from './GuestChatWidget';
import './landing.scss';
import SeoHead from '../../../Components/Common/SeoHead';

// [STORE_v1.0.3] Enerfix Limited tescilli adresi (Companies House, şirket no 12444545 — 19 Eyl 2026, Baris verdi).
// Google Payments doğrulaması ve Web Store trader beyanındaki adresle BİREBİR aynı olmalı (Google karşılaştırıyor);
// biri değişirse üçü birden güncellenir.
const REGISTERED_OFFICE = 'C/O Unit 4, Kinetica, 13 Ramsgate Street, London, E8 2FD, United Kingdom';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="layout-wrapper landing">
      <SeoHead
        title="Privacy Policy — CodeRom"
        description="CodeRom privacy policy. How CodeRom collects, uses and protects your data."
      />
      <Navbar />

      <div style={{
        maxWidth: '800px',
        margin: '0 auto',
        padding: '120px 20px 60px'
      }}>
        {/* Breadcrumb */}
        <div style={{ marginBottom: '24px', fontSize: '14px' }}>
          <Link to="/" style={{ color: '#6366f1', textDecoration: 'none' }}>Home</Link>
          <span style={{ margin: '0 8px', color: '#9ca3af' }}>›</span>
          <span style={{ color: '#6b7280' }}>Privacy Policy</span>
        </div>

        {/* Başlık kartı */}
        <div style={{
          background: 'linear-gradient(135deg, #1e1b4b 0%, #312e81 100%)',
          borderRadius: '16px',
          padding: '40px',
          marginBottom: '32px',
          color: 'white'
        }}>
          <h1 style={{ fontSize: '32px', fontWeight: 700, margin: '0 0 8px' }}>Privacy Policy</h1>
          <p style={{ fontSize: '14px', opacity: 0.8, margin: 0 }}>Last updated: September 2026 · Enerfix Limited</p>
        </div>

        {/* Ana içerik kartı */}
        <div style={{
          background: '#ffffff',
          borderRadius: '16px',
          border: '1px solid #e5e7eb',
          padding: '40px',
          boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
        }}>

          {/* Section 1 */}
          <div>
            <h2 style={{
              fontSize: '22px',
              fontWeight: 600,
              color: '#1e1b4b',
              marginTop: 0,
              marginBottom: '16px',
              paddingBottom: '12px',
              borderBottom: '2px solid #e5e7eb'
            }}>
              1. Introduction
            </h2>
            <p style={{ fontSize: '15px', lineHeight: '1.7', color: '#374151', marginBottom: '12px' }}>
              Enerfix Limited ("we", "our", "us"), trading as Coderom, is committed to protecting your privacy.
              This Privacy Policy explains how we collect, use, store, and protect your personal data when you
              use our platform at <strong>app.coderom.com</strong> and our website at <strong>www.coderom.com</strong>.
            </p>
            <p style={{ fontSize: '15px', lineHeight: '1.7', color: '#374151', marginBottom: '16px' }}>
              Enerfix Limited is the data controller for the purposes of the UK General Data Protection Regulation
              (UK GDPR) and the Data Protection Act 2018.
            </p>
            <div style={{
              background: '#eff6ff',
              borderLeft: '4px solid #3b82f6',
              borderRadius: '0 12px 12px 0',
              padding: '16px 20px',
              margin: '20px 0'
            }}>
              <p style={{ color: '#1e40af', fontSize: '14px', margin: 0 }}>
                <strong>Company details:</strong><br />
                Enerfix Limited<br />
                Registered in England and Wales, company number 12444545<br />
                Registered office: {REGISTERED_OFFICE}<br />
                Email: support@coderom.com
              </p>
            </div>
          </div>

          {/* Section 2 */}
          <div>
            <h2 style={{
              fontSize: '22px',
              fontWeight: 600,
              color: '#1e1b4b',
              marginTop: '40px',
              marginBottom: '16px',
              paddingBottom: '12px',
              borderBottom: '2px solid #e5e7eb'
            }}>
              2. Information we collect
            </h2>
            <p style={{ fontSize: '15px', lineHeight: '1.7', color: '#374151', marginBottom: '16px' }}>
              We collect the following types of personal data:
            </p>

            <div style={{
              overflowX: 'auto',
              margin: '20px 0',
              borderRadius: '12px',
              border: '1px solid #e5e7eb'
            }}>
              <table style={{
                width: '100%',
                borderCollapse: 'collapse',
                fontSize: '14px'
              }}>
                <thead>
                  <tr style={{ background: '#f8fafc' }}>
                    <th style={{
                      textAlign: 'left',
                      padding: '12px 16px',
                      fontWeight: 600,
                      color: '#374151',
                      borderBottom: '1px solid #e5e7eb'
                    }}>Data type</th>
                    <th style={{
                      textAlign: 'left',
                      padding: '12px 16px',
                      fontWeight: 600,
                      color: '#374151',
                      borderBottom: '1px solid #e5e7eb'
                    }}>Examples</th>
                    <th style={{
                      textAlign: 'left',
                      padding: '12px 16px',
                      fontWeight: 600,
                      color: '#374151',
                      borderBottom: '1px solid #e5e7eb'
                    }}>Why we collect it</th>
                  </tr>
                </thead>
                <tbody>
                  <tr style={{ borderBottom: '1px solid #f3f4f6' }}>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>Account information</td>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>Email address, name, password</td>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>To create and manage your account</td>
                  </tr>
                  <tr style={{ borderBottom: '1px solid #f3f4f6', background: '#fafafa' }}>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>Billing information</td>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>Payment method, billing address</td>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>To process subscription payments</td>
                  </tr>
                  <tr style={{ borderBottom: '1px solid #f3f4f6' }}>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>eBay account data</td>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>eBay username, store name, listings</td>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>To provide our automation services</td>
                  </tr>
                  <tr style={{ borderBottom: '1px solid #f3f4f6', background: '#fafafa' }}>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>Amazon data</td>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>Product prices, availability</td>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>To sync prices and stock for your listings</td>
                  </tr>
                  <tr style={{ borderBottom: '1px solid #f3f4f6' }}>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>Usage data</td>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>Pages visited, features used, login times</td>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>To improve our platform</td>
                  </tr>
                  <tr style={{ borderBottom: '1px solid #f3f4f6', background: '#fafafa' }}>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>Technical data</td>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>IP address, browser type, device info</td>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>For security and troubleshooting</td>
                  </tr>
                  <tr>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>Communication data</td>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>Support tickets, chat messages</td>
                    <td style={{ padding: '12px 16px', color: '#374151' }}>To provide customer support</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Section 3 */}
          <div>
            <h2 style={{
              fontSize: '22px',
              fontWeight: 600,
              color: '#1e1b4b',
              marginTop: '40px',
              marginBottom: '16px',
              paddingBottom: '12px',
              borderBottom: '2px solid #e5e7eb'
            }}>
              3. How we use your data
            </h2>
            <ul style={{
              listStyle: 'none',
              padding: 0,
              margin: '16px 0'
            }}>
              {[
                'To provide and maintain our dropshipping automation services',
                'To process your subscription payments',
                'To send you important account notifications',
                'To send daily reports (if enabled)',
                'To provide customer support',
                'To improve our platform and develop new features',
                'To comply with legal obligations'
              ].map((item, index) => (
                <li key={index} style={{
                  padding: '8px 0 8px 28px',
                  position: 'relative',
                  fontSize: '15px',
                  lineHeight: '1.7',
                  color: '#374151'
                }}>
                  <span style={{
                    position: 'absolute',
                    left: 0,
                    color: '#6366f1',
                    fontWeight: 'bold'
                  }}>✓</span>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          {/* Section 4 */}
          <div>
            <h2 style={{
              fontSize: '22px',
              fontWeight: 600,
              color: '#1e1b4b',
              marginTop: '40px',
              marginBottom: '16px',
              paddingBottom: '12px',
              borderBottom: '2px solid #e5e7eb'
            }}>
              4. Legal basis for processing (UK GDPR)
            </h2>
            <ul style={{
              listStyle: 'none',
              padding: 0,
              margin: '16px 0'
            }}>
              {[
                { title: 'Contract:', text: 'Processing necessary to provide our services to you' },
                { title: 'Legitimate interest:', text: 'Platform improvement, security, fraud prevention' },
                { title: 'Consent:', text: 'Marketing emails, cookies (where required)' },
                { title: 'Legal obligation:', text: 'Tax records, regulatory compliance' }
              ].map((item, index) => (
                <li key={index} style={{
                  padding: '8px 0 8px 28px',
                  position: 'relative',
                  fontSize: '15px',
                  lineHeight: '1.7',
                  color: '#374151'
                }}>
                  <span style={{
                    position: 'absolute',
                    left: 0,
                    color: '#6366f1',
                    fontWeight: 'bold'
                  }}>✓</span>
                  <strong>{item.title}</strong> {item.text}
                </li>
              ))}
            </ul>
          </div>

          {/* Section 5 */}
          <div>
            <h2 style={{
              fontSize: '22px',
              fontWeight: 600,
              color: '#1e1b4b',
              marginTop: '40px',
              marginBottom: '16px',
              paddingBottom: '12px',
              borderBottom: '2px solid #e5e7eb'
            }}>
              5. Data sharing
            </h2>
            <p style={{ fontSize: '15px', lineHeight: '1.7', color: '#374151', marginBottom: '16px' }}>
              <strong>We do not sell your personal data.</strong> We share data only with:
            </p>
            <ul style={{
              listStyle: 'none',
              padding: 0,
              margin: '16px 0'
            }}>
              {[
                { title: 'eBay', text: '(via API, to manage your listings — you authorise this when connecting your store)' },
                { title: 'Payment processors', text: '(Stripe, PayPal — to process your payments)' },
                { title: 'Email service providers', text: '(to send notifications and reports)' },
                { title: 'Hosting providers', text: '(to store data securely)' }
              ].map((item, index) => (
                <li key={index} style={{
                  padding: '8px 0 8px 28px',
                  position: 'relative',
                  fontSize: '15px',
                  lineHeight: '1.7',
                  color: '#374151'
                }}>
                  <span style={{
                    position: 'absolute',
                    left: 0,
                    color: '#6366f1',
                    fontWeight: 'bold'
                  }}>✓</span>
                  <strong>{item.title}</strong> {item.text}
                </li>
              ))}
            </ul>
          </div>

          {/* Section 6 */}
          <div>
            <h2 style={{
              fontSize: '22px',
              fontWeight: 600,
              color: '#1e1b4b',
              marginTop: '40px',
              marginBottom: '16px',
              paddingBottom: '12px',
              borderBottom: '2px solid #e5e7eb'
            }}>
              6. Data storage and security
            </h2>
            <ul style={{
              listStyle: 'none',
              padding: 0,
              margin: '16px 0'
            }}>
              {[
                'Data stored on secure servers within the European Economic Area',
                'Encrypted in transit (TLS/SSL) and at rest',
                'Regular security audits and updates',
                'Access restricted to authorised personnel only'
              ].map((item, index) => (
                <li key={index} style={{
                  padding: '8px 0 8px 28px',
                  position: 'relative',
                  fontSize: '15px',
                  lineHeight: '1.7',
                  color: '#374151'
                }}>
                  <span style={{
                    position: 'absolute',
                    left: 0,
                    color: '#6366f1',
                    fontWeight: 'bold'
                  }}>✓</span>
                  {item}
                </li>
              ))}
            </ul>
          </div>

          {/* Section 7 */}
          <div>
            <h2 style={{
              fontSize: '22px',
              fontWeight: 600,
              color: '#1e1b4b',
              marginTop: '40px',
              marginBottom: '16px',
              paddingBottom: '12px',
              borderBottom: '2px solid #e5e7eb'
            }}>
              7. Data retention
            </h2>
            <ul style={{
              listStyle: 'none',
              padding: 0,
              margin: '16px 0'
            }}>
              {[
                { title: 'Account data:', text: 'Retained while your account is active, deleted within 30 days of account closure' },
                { title: 'Billing records:', text: 'Retained for 7 years (UK tax requirements)' },
                { title: 'Usage logs:', text: 'Retained for 12 months' },
                { title: 'Support tickets:', text: 'Retained for 24 months' }
              ].map((item, index) => (
                <li key={index} style={{
                  padding: '8px 0 8px 28px',
                  position: 'relative',
                  fontSize: '15px',
                  lineHeight: '1.7',
                  color: '#374151'
                }}>
                  <span style={{
                    position: 'absolute',
                    left: 0,
                    color: '#6366f1',
                    fontWeight: 'bold'
                  }}>✓</span>
                  <strong>{item.title}</strong> {item.text}
                </li>
              ))}
            </ul>
          </div>

          {/* Section 8 */}
          <div>
            <h2 style={{
              fontSize: '22px',
              fontWeight: 600,
              color: '#1e1b4b',
              marginTop: '40px',
              marginBottom: '16px',
              paddingBottom: '12px',
              borderBottom: '2px solid #e5e7eb'
            }}>
              8. Your rights (UK GDPR)
            </h2>
            <p style={{ fontSize: '15px', lineHeight: '1.7', color: '#374151', marginBottom: '16px' }}>
              You have the right to:
            </p>
            <ul style={{
              listStyle: 'none',
              padding: 0,
              margin: '16px 0'
            }}>
              {[
                'Access your personal data',
                'Correct inaccurate data',
                'Delete your data ("right to be forgotten")',
                'Restrict processing',
                'Data portability',
                'Object to processing',
                'Withdraw consent at any time'
              ].map((item, index) => (
                <li key={index} style={{
                  padding: '8px 0 8px 28px',
                  position: 'relative',
                  fontSize: '15px',
                  lineHeight: '1.7',
                  color: '#374151'
                }}>
                  <span style={{
                    position: 'absolute',
                    left: 0,
                    color: '#6366f1',
                    fontWeight: 'bold'
                  }}>✓</span>
                  {item}
                </li>
              ))}
            </ul>
            <div style={{
              background: '#eff6ff',
              borderLeft: '4px solid #3b82f6',
              borderRadius: '0 12px 12px 0',
              padding: '16px 20px',
              margin: '20px 0'
            }}>
              <p style={{ color: '#1e40af', fontSize: '14px', margin: 0 }}>
                <strong>Your rights:</strong> You can request access to, correction of, or deletion of your personal data at any time by contacting <a href="mailto:support@coderom.com" style={{ color: '#1e40af', textDecoration: 'underline' }}>support@coderom.com</a>
              </p>
            </div>
          </div>

          {/* Section 9 */}
          <div>
            <h2 style={{
              fontSize: '22px',
              fontWeight: 600,
              color: '#1e1b4b',
              marginTop: '40px',
              marginBottom: '16px',
              paddingBottom: '12px',
              borderBottom: '2px solid #e5e7eb'
            }}>
              9. Cookies
            </h2>
            <p style={{ fontSize: '15px', lineHeight: '1.7', color: '#374151', marginBottom: '16px' }}>
              We use cookies to keep you logged in and improve your experience. See our{' '}
              <Link to="/cookies" style={{ color: '#6366f1', textDecoration: 'none', fontWeight: 500 }}>Cookie Policy</Link> for full details.
            </p>
          </div>

          {/* Section 10 */}
          <div>
            <h2 style={{
              fontSize: '22px',
              fontWeight: 600,
              color: '#1e1b4b',
              marginTop: '40px',
              marginBottom: '16px',
              paddingBottom: '12px',
              borderBottom: '2px solid #e5e7eb'
            }}>
              10. Children
            </h2>
            <p style={{ fontSize: '15px', lineHeight: '1.7', color: '#374151', marginBottom: '16px' }}>
              Our services are not intended for anyone under 18. We do not knowingly collect data from minors.
            </p>
          </div>

          {/* Section 11 — Chrome uzantisi (Web Store v1.0.3 icin zorunlu) */}
          <div>
            <h2 style={{
              fontSize: '22px',
              fontWeight: 600,
              color: '#1e1b4b',
              marginTop: '40px',
              marginBottom: '16px',
              paddingBottom: '12px',
              borderBottom: '2px solid #e5e7eb'
            }}>
              11. Chrome extension
            </h2>
            <p style={{ fontSize: '15px', lineHeight: '1.7', color: '#374151', marginBottom: '16px' }}>
              The Coderom browser extension runs only while you are signed in to Coderom, and only on
              amazon.co.uk and app.coderom.com. It acts inside your own Amazon account, after you start a
              fulfilment in Coderom.
            </p>
            <p style={{ fontSize: '15px', lineHeight: '1.7', color: '#374151', marginBottom: '8px' }}>
              <strong>Data the extension handles</strong>
            </p>
            <ul style={{ fontSize: '15px', lineHeight: '1.8', color: '#374151', marginBottom: '16px', paddingLeft: '22px' }}>
              <li>Order data from your Coderom account: item, quantity, price limits and your buyer's delivery address.</li>
              <li>Your Coderom authentication token, kept in the browser's extension storage so the extension can reach our API.</li>
              <li>Diagnostic records of each fulfilment attempt: the step reached, the seller, price and delivery date seen, and the reason an order was held.</li>
            </ul>
            <p style={{ fontSize: '15px', lineHeight: '1.7', color: '#374151', marginBottom: '8px' }}>
              <strong>What the extension does not do</strong>
            </p>
            <ul style={{ fontSize: '15px', lineHeight: '1.8', color: '#374151', marginBottom: '16px', paddingLeft: '22px' }}>
              <li>It does not read or store your Amazon password.</li>
              <li>It does not collect your browsing history or any page outside amazon.co.uk and app.coderom.com.</li>
              <li>It does not sell or share this data with third parties, and it is never used for advertising.</li>
            </ul>
            <p style={{ fontSize: '15px', lineHeight: '1.7', color: '#374151', marginBottom: '16px' }}>
              <strong>Retention.</strong> Diagnostic records are kept for up to 90 days. Order data follows the
              retention period described in section 6.
            </p>
            <p style={{ fontSize: '15px', lineHeight: '1.7', color: '#374151', marginBottom: '16px' }}>
              <strong>Data controller.</strong> Enerfix Limited, registered in England and Wales, company number
              12444545, registered office {REGISTERED_OFFICE}. Contact{' '}
              <a href="mailto:support@coderom.com" style={{ color: '#6366f1' }}>support@coderom.com</a>.
            </p>
          </div>

          {/* Section 12 */}
          <div>
            <h2 style={{
              fontSize: '22px',
              fontWeight: 600,
              color: '#1e1b4b',
              marginTop: '40px',
              marginBottom: '16px',
              paddingBottom: '12px',
              borderBottom: '2px solid #e5e7eb'
            }}>
              12. Changes to this policy
            </h2>
            <p style={{ fontSize: '15px', lineHeight: '1.7', color: '#374151', marginBottom: '16px' }}>
              We may update this policy from time to time. We will notify you of significant changes via email
              or a notice on our platform.
            </p>
          </div>

          {/* Contact bölümü */}
          <div style={{
            background: '#f8fafc',
            borderRadius: '12px',
            padding: '24px',
            marginTop: '40px',
            textAlign: 'center'
          }}>
            <h3 style={{ fontSize: '18px', fontWeight: 600, color: '#1e1b4b', margin: '0 0 8px' }}>
              Questions about this policy?
            </h3>
            <p style={{ fontSize: '14px', color: '#6b7280', margin: '0 0 16px' }}>
              Contact our team at <a href="mailto:support@coderom.com" style={{ color: '#6366f1' }}>support@coderom.com</a>
            </p>
            <Link to="/" style={{
              display: 'inline-block',
              padding: '10px 24px',
              background: '#6366f1',
              color: 'white',
              borderRadius: '8px',
              textDecoration: 'none',
              fontSize: '14px',
              fontWeight: 500
            }}>
              ← Back to Home
            </Link>
          </div>

        </div>
      </div>

      <Footer />
      <GuestChatWidget />
    </div>
  );
};

export default PrivacyPolicy;
